import React from 'react';
import { Mail } from 'lucide-react';
import { Card, CardContent } from '../../../../components/ui/card';
import { Input } from '../../../../components/ui/input';
import type { SystemSettings } from '../../types';

interface EmailSettingsProps {
  settings: SystemSettings['email'];
  onSettingChange: (field: keyof SystemSettings['email'], value: string | number) => void;
}

export const EmailSettings: React.FC<EmailSettingsProps> = ({
  settings,
  onSettingChange
}) => {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold flex items-center gap-2">
        <Mail className="h-5 w-5 text-[#e04530]" />
        Email Configuration
      </h2>
      <Card className="border border-gray-200 bg-white">
        <CardContent className="p-6 space-y-4">
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="text-sm font-medium mb-1.5 block">SMTP Server</label>
              <Input 
                placeholder="smtp.example.com" 
                className="bg-white"
                value={settings.smtpServer}
                onChange={(e) => onSettingChange('smtpServer', e.target.value)}
              />
            </div>
            <div>
              <label className="text-sm font-medium mb-1.5 block">SMTP Port</label>
              <Input 
                placeholder="587" 
                className="bg-white"
                type="number"
                value={settings.smtpPort}
                onChange={(e) => onSettingChange('smtpPort', parseInt(e.target.value, 10))}
              />
            </div>
            <div>
              <label className="text-sm font-medium mb-1.5 block">Email From Address</label>
              <Input 
                placeholder="noreply@example.com" 
                className="bg-white"
                value={settings.fromAddress}
                onChange={(e) => onSettingChange('fromAddress', e.target.value)}
              />
            </div>
            <div>
              <label className="text-sm font-medium mb-1.5 block">Email From Name</label>
              <Input 
                placeholder="System Administrator" 
                className="bg-white"
                value={settings.fromName}
                onChange={(e) => onSettingChange('fromName', e.target.value)}
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}; 